export default __webpack_public_path__ + "static/media/pharmax_card.aa008b9f.png";